var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1117 4.95234C3.26087 -0.099328 10.745 -0.0934945 11.8884 4.95817C12.5592 7.9215 10.7159 10.4298 9.10003 11.9815C7.92753 13.1132 6.07253 13.1132 4.8942 11.9815C3.2842 10.4298 1.44087 7.91567 2.1117 4.95234Z",
    fill: "#272927"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99993 7.83434C8.00509 7.83434 8.81993 7.01949 8.81993 6.01434C8.81993 5.00918 8.00509 4.19434 6.99993 4.19434C5.99477 4.19434 5.17993 5.00918 5.17993 6.01434C5.17993 7.01949 5.99477 7.83434 6.99993 7.83434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.64043f119ec6470085b74d1ab0e1e27a.svg";
export { ForwardRef as ReactComponent };